export default __webpack_public_path__ + "static/media/asahi_markets_logo.911d0b73.svg";